import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardComponent } from './components/card/card.component';
import { IonicModule } from '@ionic/angular';

import { MarkdownPipe } from './pipes/markdown.pipe';
import { TrelloService } from './services/trello.service';
import { ScorecardsComponent } from './components/scorecards/scorecards.component';

@NgModule({
	declarations: [
		MarkdownPipe,
		CardComponent,
		ScorecardsComponent
	],
	imports: [
		CommonModule,
		IonicModule
	],
	exports: [
		MarkdownPipe,
		CardComponent,
		ScorecardsComponent
	],
	providers: [
		MarkdownPipe,
		TrelloService
	]

})
export class SharedModule { }
